import React from 'react'
import injectSheet from 'react-jss'
import styles from './provider.styles'
import TrashIcon from 'react-icons/lib/fa/trash-o'
import { openConfirmationDialog } from 'pobble-components/dist/modal/confirmation-dialog'

const Provider = ({ classes, Icon, children, onRemove, color }) => (
  <li className={classes.provider}>
    <div className={classes.iconHolder} style={{ backgroundColor: color }}>
      <Icon className={classes.icon} />
    </div>
    {children}
    <TrashIcon
      className={classes.delete}
      onClick={() =>
        openConfirmationDialog({
          bodyText: `Are you sure you want to remove ${children} from the list of providers?`,
          confirmText: 'Remove',
          action: () => onRemove()
        })
      }
    />
  </li>
)

export default injectSheet(styles)(Provider)
